import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import styles from "./index.module.css";
import { Scrollbars } from "react-custom-scrollbars";
import { Button, Tooltip } from "antd";
import "antd/es/button/style/css";
import "antd/es/tooltip/style/css";
import cs from "classnames";
import { isSafari } from "@/utils";
import { RICH_TEXT_MAX_LEN } from "@/constants/workbench";
import event from "@/utils/event";
import MarkdownEditor from "@/components/markdownEditor";
import { Editor } from "@tiptap/react";

interface MdEditorProps {
  onChange?: (markdown: string, html: string, len: number) => void;
  value?: string;
  visibleTooltip?: boolean;
  onBlur?: () => void;
  disabled?: boolean;
  onClick?: () => void;
}

const MdEditor = forwardRef((props: MdEditorProps, ref) => {
  const {
    onChange,
    value,
    visibleTooltip = false,
    onBlur,
    disabled,
    onClick,
  } = props;
  const [visible, setVisible] = useState(visibleTooltip);
  const editorRef = useRef<{
    editor: () => Editor;
  }>(null);

  useEffect(() => {
    event.on("AI_PPT_SCROLL", () => {
      setVisible(false);
    });
    return () => {
      event.off("AI_PPT_SCROLL", () => {});
    };
  }, []);

  useEffect(() => {
    setVisible(visibleTooltip);
  }, [visibleTooltip]);

  useImperativeHandle(ref, () => ({
    getEditor: () => editorRef.current?.editor(),
  }));

  return (
    <>
      <div className={styles.mdEditor}>
        {/* @ts-ignore */}
        <Scrollbars
          className={cs(styles.mdEditorWrapper, {
            [styles.mdEditorWrapperSafari]: isSafari(),
          })}
        >
          <MarkdownEditor
            ref={editorRef}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
          />
        </Scrollbars>
        <Tooltip
          open={visible}
          title="请删除超出字数限制部分"
          placement="bottom"
        >
          <div
            id="len-info"
            className={cs(styles.lenInfo, {
              [styles.lenInfoError]:
                editorRef.current
                  ?.editor()
                  ?.storage.characterCount.characters() > RICH_TEXT_MAX_LEN,
            })}
          >
            {editorRef.current?.editor()?.storage.characterCount.characters()} /{" "}
            {RICH_TEXT_MAX_LEN}
          </div>
        </Tooltip>
        <Button data-blue disabled={disabled} type="primary" onClick={onClick}>
          免费生成大纲
        </Button>
      </div>
    </>
  );
});

MdEditor.displayName = "MdEditor";

export default React.memo(MdEditor);
